var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBankCardLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#070d1a",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10 6a2 2 0 0 0-2 2v1h16V8a2 2 0 0 0-2-2zm14 5H8v5c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2z",
  clipRule: "evenodd"
})));
export default SvgBankCardLight;